import $ from 'jquery';
import * as Sentry from '@sentry/browser';
import Cookies from 'js-cookie';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/blur-up/ls.blur-up';
import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css/core';
const _throttle = require('lodash.throttle');
const _debounce = require('lodash.debounce');
import Rellax from 'rellax'

window.lazySizes = lazySizes;
window.Sentry = Sentry;
window.jQuery = $;
window.$ = $;
window.Cookies = Cookies;
window.Splide = Splide;
window._throttle = _throttle;
window._debounce = _debounce;
window.Rellax = Rellax;